export default __webpack_public_path__ + "static/media/Thumb_Bottom_01.27010266.png";